import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import eventHub from './mixins/eventHub'
import storagePlugin from './plugins/storagePlugin';
import i18n from './plugins/i18n'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import translate from "./mixins/translate";
import localeSort from "./plugins/czechSlovakAlphabetPlugin";
import sounds from "@/utils/sounds";
import moment from 'moment'
import {LogUtils} from "@/utils/logUtils";

Vue.mixin({
  methods: {
    translate,
    localeSort
  }
});
Vue.config.productionTip = false;
Vue.prototype.$eventHub = eventHub; // Global event bus
Vue.prototype.$time = (time) => moment(time).utc().format('HH:mm:ss')

Raven
    .config(process.env.VUE_APP_SENTRY_DNS, {
      release: process.env.VUE_APP_VERSION_VALUE
    })
    .addPlugin(RavenVue, Vue)
    .install();

eventHub.$on('openMessageController', (type, message) => {
  if(type === 'error'){
    Raven.captureMessage(`error message '${message}'`);
  }
});

sounds.store = store;
LogUtils._setStore(store)


new Vue({
  router,
  store,
  i18n,
  sounds,
  render: h => h(App),
  created(){
    storagePlugin.registerListener(store);
    storagePlugin.loadInitialData(store);
  }
}).$mount('#app')

window.moment = moment
